import React, { useState } from 'react';
import { StaticImageData } from 'next/image';
import { useTheme } from 'styled-components';

import { LinkButtonProps } from 'Elements/Button';
import Section from 'Elements/Section/Section';

import Grid from 'Components/Grid/Grid';
import { Col } from 'Components/Grid';

import {
    PromoPoint,
    Heading,
    Text,
    ArrowButton,
    ImagesListItem,
    ItemImage,
    SixImagesList,
    FourImagesList
} from './Publication.styled';

export interface Props {
    id: string;
    header: string;
    images: {
        alt: string;
        src: StaticImageData | string;
    }[];
    text: string;
    link: LinkButtonProps;
}

const PublicationPromoPoint: React.FC<Props> = props => {
    const { id, header, images, text, link } = props;
    const { colors } = useTheme();
    const [tabletImages] = useState(images.slice(0, 4));

    const renderImage = (image, index) => (
        <ImagesListItem key={image.alt + ` ${index}`}>
            <ItemImage {...image} fill style={{ objectFit: 'cover' }} />
        </ImagesListItem>
    );

    return (
        <Section
            paddingBottom={2}
            id={id}
            backgroundColor={colors.secondary.tints[1].hex}
            background={true}
        >
            <Grid>
                <Col>
                    <PromoPoint>
                        <Heading>{header}</Heading>
                        <SixImagesList>
                            {images.map((image, index) => renderImage(image, index))}
                        </SixImagesList>
                        <FourImagesList>
                            {tabletImages.map((image, index) => renderImage(image, index))}
                        </FourImagesList>
                        <Text>{text}</Text>
                        <ArrowButton {...link} />
                    </PromoPoint>
                </Col>
            </Grid>
        </Section>
    );
};

export default PublicationPromoPoint;
